import React from 'react';

import { useTranslation } from 'react-i18next';

import Stat from './Stat';

import classes from './styles.module.scss';

// function calculateRatio(n1, n2) {
//   let num1 = n1;
//   let num2 = n2;
//   // eslint-disable-next-line no-plusplus
//   for (let num = num2; num > 1; num--) {
//     if (num1 % num === 0 && num2 % num === 0) {
//       num1 /= num;
//       num2 /= num;
//     }
//   }
//   const ratio = `${num1}:${num2}`;
//   return ratio;
// }

export default function StatsList({ data }) {
  const { t } = useTranslation();
  const stats = [
    {
      label: t('dashboardComponents.CompanyDashboard.StatsList.OpenRoles'),
      value: data?.openRoles || 0,
    },
    {
      label: t('dashboardComponents.CompanyDashboard.StatsList.NewSubmissions'),
      value: data?.newSubmissions || 0,
      note: 'last 7 days',
    },
    {
      label: t('dashboardComponents.CompanyDashboard.StatsList.AwaitingReview'),
      value: data?.awaitingReview || 0,
    },
    {
      label: t('dashboardComponents.CompanyDashboard.StatsList.Interviews'),
      value: data?.interview || 0,
      note: 'next 7 days',
    },
    {
      label: t('dashboardComponents.CompanyDashboard.StatsList.FeedbackDue'),
      value: data?.feedbackDue || 0,
    },
    {
      label: t('dashboardComponents.CompanyDashboard.StatsList.Offer'),
      value: `${data?.offers}:${data?.acceptedOffers}`,
      note: 'Out / Accepted',
    },
    {
      label: t(
        'dashboardComponents.CompanyDashboard.StatsList.CandidatesPerHire'
      ),
      value: `${Math.round(data?.candidatePerHire) || 0}:1`,
    },
    {
      label: t(
        'dashboardComponents.CompanyDashboard.StatsList.JoinedCandidates'
      ),
      value: data?.hires || 0,
    },
  ];

  return (
    <div className={classes.StatsList}>
      {stats.map((stat) => {
        return (
          <Stat
            key={stat.label}
            label={stat.label}
            value={stat.value}
            note={stat.note}
            hasNoData={!data}
          />
        );
      })}
    </div>
  );
}
